import React from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent } from '@/components/ui/dialog';

interface ConfirmEntryModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
}

/**
 * "Confirm Entry" modal — DKPLAT-528. Opens when the user taps "Enter | Free"
 * on the Reserve panel. Built on the shared Dialog primitive. DialogContent
 * already renders the X dismiss button
 * top-right by default (see components/ui/dialog.tsx), which matches the
 * visual spec without any extra markup here.
 */
const ConfirmEntryModal: React.FC<ConfirmEntryModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isSubmitting = false,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        data-test-id="confirm-entry-modal"
        className="bg-app-background border-border/30 w-[calc(100%-2rem)] max-w-md mx-auto rounded-xl p-6"
      >
        <div className="text-center space-y-6 pt-2">
          <h2 className="text-text-primary font-bold text-xl tracking-wide">Confirm Entry</h2>

          <div className="space-y-3">
            <Button
              data-test-id="confirm-entry-submit-btn"
              variant="pickem"
              onClick={onConfirm}
              disabled={isSubmitting}
              className="w-full"
            >
              Submit | Free
            </Button>
            <Button
              data-test-id="confirm-entry-cancel-btn"
              variant="outline"
              onClick={onClose}
              disabled={isSubmitting}
              className="w-full bg-transparent border-pickem-primary text-pickem-primary hover:bg-pickem-primary/10"
            >
              Cancel
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmEntryModal;
